import WebComponent from "../../../WebComponent";
import {css, html} from "@isceco/widget-library2/external/lit";
import logo from '../../../assets/logo_SBFI_EinfachBesser.svg';

export default class Sbfi extends WebComponent {

  chosenRequest = "1";

  constructor() {
    super()
  }
  get translationFile() {
    return './views/WBF/SBFI/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload();
  }

  get css() {
    return css`
      .row {
        display: flex;
        gap: 3rem;
      }
      .row ul {
        list-style: disc;
      }
      .row ul li {
        padding: 0.5rem 0;
      }

      .left {
        flex: 0 0 70%;
      }

      .right {
        flex: 0 0 30%;
      }
      .right img {
        width: 80%;
      }
      .cardspace {
        display: grid;
        gap: 20px;
      }
      .contact {
        display: grid;
      }
      #decisionCard {
        display: flex;
        gap: 20px;
        align-items: center;
      }
      .button-area {
        display: flex;
        justify-content: flex-end;
        padding: 20px;
      }
    `;
  }
  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('sbfi.title')}">
      </isceco-title>
      <div class="cardspace">
        <isceco-card text="${this.i18n.translate('sbfi.requirement.header')}">
          <div class="row">
            <div class="left">
              <p>${this.i18n.translate('sbfi.requirement.list.header')}</p>
              <ul>
                <li>
                  ${this.i18n.translate('sbfi.requirement.list.line1.part1')}
                  <a href="https://www.einfach-besser.ch/wp-content/uploads/AM_ARBEITSPLATZ_DOC_INFO_DE_2025.pdf"
                     target="_blank"
                     rel="noopener noreferrer">
                    ${this.i18n.translate('sbfi.requirement.list.line1.link')}
                  </a>
                  ${this.i18n.translate('sbfi.requirement.list.line1.part2')}
                </li>
                <li>${this.i18n.translate('sbfi.requirement.list.line2')}</li>
                <li>${this.i18n.translate('sbfi.requirement.list.line3')}</li>
                <li>${this.i18n.translate('sbfi.requirement.list.line4')}</li>
                <li>${this.i18n.translate('sbfi.requirement.list.line5')}</li>
                <li>${this.i18n.translate('sbfi.requirement.list.line6')}</li>
                <li>${this.i18n.translate('sbfi.requirement.list.line7')}</li>
              </ul>
            </div>
            <div class="right">
              <img src="${logo}"
                   alt="Logo EinfachBesser">
            </div>
          </div>
        </isceco-card>
        <isceco-card class="contact">
          <h4>${this.i18n.translate('sbfi.contact.header')}</h4>
          <span>${this.i18n.translate('sbfi.contact.organisation')}</span>
          <span>Joel Reeves</span>
          <span>058 463 99 30</span>
          <span><a href="mailto:joelmatthew.reeves@sbfi.admin.ch">joelmatthew.reeves@sbfi.admin.ch</a></span>
        </isceco-card>
        <isceco-card id="decisionCard">
          <isceco-radio-group
            label="${this.i18n.translate('sbfi.request.or.report')}"
            help-text="${this.i18n.translate('sbfi.request.or.report.help')}"
            .value="${this.chosenRequest}"
            .items="${[{value: '1', name: this.i18n.translate('sbfi.request')}, {value: '2', name: this.i18n.translate('sbfi.report')}]}"
            inline
            @change="${this._requestChange}"
          ></isceco-radio-group>
        </isceco-card>
      </div>
      <div class="button-area">
        <isceco-button text="${this.i18n.translate('sbfi.button')}"
                       id="nextButton"
                       @click="${this._onNextButtonClicked}"
                       variant="primary">
        </isceco-button>
      </div>
    `
  }
  _requestChange = e => {
    this.chosenRequest = e.detail?.value
  }
  _onNextButtonClicked = () => {
    if (this.chosenRequest === "1") {
      navigate({to: 'wbf-sbfi-gesuchformular-gesuch'});
    } else if (this.chosenRequest === "2") {
      navigate({to: 'wbf-sbfi-gesuchformular-reporting'});
    }
  }

}
customElements.define('eform-sbfi', Sbfi)
